<template>
  <div></div>
</template>

<script>
import { db } from '@/shared/firebase'

export default {
  props: {
    product: {
      type: String,
      required: true
    },
    env: {
      type: String,
      required: true
    }
  },
  created() {
    db.doc(`public/app`).onSnapshot(doc => {
      const newVersion = doc.data().version[this.product][this.env]
      this.compareVersions(newVersion)
    })
  },
  methods: {
    compareVersions(newVersion) {
      const prevVersion = process.env.VUE_APP_VERSION
      const updateApp = newVersion.localeCompare(prevVersion, undefined, { numeric: true })
      if (updateApp === 1) {
        const confirmed = confirm('Eine neue Version ist verfügbar. Bitte laden Sie die Anwendung jetzt neu.')
        if (confirmed) window.location.reload(true)
      }
    }
  }
}
</script>
